import type { MyReview } from "../../lib/marketplace-connection-api";

/**
 * Non-component exports for `ReviewedProAction` — the repo's Fast Refresh
 * convention (a `.tsx` exporting a component must not also export values).
 */

export type ProRole = "agent" | "lo" | (string & {});

/**
 * The review CTA label, role-aware.
 *
 * The passive affordance shipped as "Review your agent" while it lived on its
 * own row below the whole list. On a per-pro card it sits next to a LENDER
 * too, so borrowing agent copy there would be simply wrong. An unknown or
 * missing role degrades to neutral wording rather than guessing.
 */
export function reviewActionLabel(role?: ProRole): string {
  if (role === "agent") return "Review your agent";
  if (role === "lo") return "Review your lender";
  return "Leave a review";
}

/** The closed-stage ask's CTA: the one follow-up a posted review allows. */
export function closingReviewActionLabel(): string {
  return "Add your closing review";
}

/**
 * "Reviewed {Mon D, YYYY}" for the read-only dialog, preferring the
 * created_at capture moment. Falls back to a bare label when the timestamp is
 * missing or unparseable — never renders "Invalid Date".
 */
export function reviewedOnLabel(review: Pick<MyReview, "created_at">): string {
  const parsed = new Date(review.created_at);
  if (Number.isNaN(parsed.getTime())) return "Reviewed";
  return `Reviewed ${parsed.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })}`;
}
